import { motion } from "framer-motion";

const LOOPS = {
  float: { y: [0, -6, 0] },
  point: { y: [0, -4, 0] },
  wave: {},
};

export const Toon = ({
  testId,
  variant = "float",
  className = "",
  imgClass = "",
  delay = 0,
  immediate = false,
}) => {
  const entrance = immediate
    ? { animate: { scale: 1, opacity: 1 } }
    : {
        whileInView: { scale: 1, opacity: 1 },
        viewport: { once: true, margin: "-60px" },
      };
  return (
    <motion.div
      data-testid={testId}
      initial={{ scale: 0, opacity: 0 }}
      {...entrance}
      whileHover={{
        scale: 1.25,
        transition: { type: "spring", stiffness: 300, damping: 12 },
      }}
      transition={{ type: "spring", stiffness: 260, damping: 15, delay }}
      className={`cursor-pointer ${className}`}
    >
    <motion.img
      src="/gerard-toon-anim.webp"
      alt="CallMe📲Gerard cartoon guide"
      animate={LOOPS[variant]}
      transition={{
        duration: variant === "wave" ? 1.6 : 3,
        repeat: Infinity,
        ease: "easeInOut",
      }}
      style={{
        filter: "drop-shadow(0 0 18px rgba(31,127,224,0.35))",
        transformOrigin: "bottom center",
      }}
      className={`w-32 md:w-40 ${imgClass}`}
    />
    </motion.div>
  );
};
